import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=5a03123a&scoped=true"
import script from "./orderManage.vue?vue&type=script&lang=js"
export * from "./orderManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03123a",
  null
  
)

export default component.exports